import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgPersonSolid = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.124 3.875a1.876 1.876 0 1 1-3.75-.001 1.876 1.876 0 0 1 3.75.001M11.937 15.75v5c0 .691-.559 1.25-1.25 1.25-.692 0-1.25-.559-1.25-1.25v-8.715l-1.118 1.86a1.25 1.25 0 0 1-1.714.425 1.25 1.25 0 0 1-.426-1.715l2.277-3.789a3.75 3.75 0 0 1 3.215-1.82h1.16c1.317 0 2.535.691 3.215 1.82l2.277 3.79c.356.59.164 1.359-.425 1.714-.59.356-1.36.164-1.715-.425l-1.121-1.86v8.715c0 .691-.559 1.25-1.25 1.25-.692 0-1.25-.559-1.25-1.25v-5z"
    }));
export default SvgPersonSolid;
